import {Component, HostListener, OnInit, OnDestroy, ViewEncapsulation} from '@angular/core';
import {HttpClientService} from '../../Services/http-client.service';
import {AppSettings} from '../../app-settings';
import { HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionService } from '../../Services/session.service';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { EventService } from "../../Services/event.service";

@Component({
  selector: 'app-live-sessions-info',
  templateUrl: './live-sessions-info.component.html',
  styleUrls: ['./live-sessions-info.component.css'],
  animations:[
    trigger('slideInOut', [
      state('in', style({
        height: '*'
      })),
      state('out', style({
        opacity: '0',
        overflow: 'hidden',
        height: '0px'
      })),
      transition('in => out', animate('500ms ease-in-out')),
      transition('out => in', animate('500ms ease-in-out'))
    ]),
    trigger('purchaseModalPopInOut', [
     transition(':enter', [
           style({opacity: 0}),
           animate('0.3s', style({opacity: 1}))
         ]),
     transition(':leave', [
           style({opacity: 1}),
           animate('0.3s', style({opacity: 0}))
         ])
     ])
  ],
  encapsulation: ViewEncapsulation.None,
})
export class LiveSessionsInfoComponent implements OnInit,OnDestroy {
  screenSize:number;
  state:string='';
  mainButtonText:string='';
  firstLine:string='';
  firstLineURL:string='';
  secondLine:string='';
  secondLineURL:string='';
  hideTile:boolean=false;
  hideTileContainer:boolean=true;
  btnClass:string='';
  showPurchaseModal:boolean=false;
  modalIdentifier:string='';
  section:string='';
  sectionSubscription:Subscription;
  lsInfoTemplateConfig:object = {
    "A":{
      "access-msg":"",
      "msg":"",
      "msg-2":"",
      "message_green":"",
      "headingBlack1":"",
      "subHeadingBlack":"",
      "mainButtonText":"Live Sessions 360 &nbsp;<img height='15px' src='/secure-lms/assets/images/login-square-arrow.png\'>",
      "mainButtonClick":"LINK",
      "mainButtonModalContent":"",
      "mainButtonLink":"https://e-gmat.com",
      "firstLine":"",
      "firstLineURL":"",
      "secondLine":"Read More",
      "showRenewLink":false,
      "secondLineURL":"https://e-gmat.com/",
      "hideTile":true,
      "btnClass":"ls-btn-primrary-blue"
    },
    "B":{
      "access-msg":"",
      "msg":"Build a solid foundation, master core concepts, and achieve peak performance to excel on the GMAT.",
      "headingBlack1":"Live Sessions 360",
      "msg-2":"<p class='pdt-20'>Experience LS 360 for 15 days</p>",
      "message_green":"free of charge.",
      //"msg-green":"free of charge",
      "subHeadingBlack":"(LS 360)",
      "mainButtonText":"Activate Live Sessions 360",
      "mainButtonClick":"MODAL",
      "mainButtonModalContent":"M1",
      "mainButtonLink":"",
      "firstLine":"",
      "firstLineURL":"https://e-gmat.com/",
      "showRenewLink":false,
      "secondLine":"",
      "secondLineURL":"",
      "hideTile":false,
      "btnClass":"ls-btn-primrary-blue"
    },
    "C":{
      "access-msg":"",
      "msg":"Your access expired on",
      "msg-2":'<ul><li class="list pdr">Click <a href="https://blitzkrieg.e-gmat.com/secure-lms/live-sessions/verbal/batch-selector">here</a> to check upcoming batches.</li><li class="list pdb-25">Click on the button below to renew your access.</li></ul>',
      "message_green":"",
      "headingBlack1":"Live Sessions 360",
      "subHeadingBlack":"(LS 360)",
      "mainButtonText":"Purchase LS 360",
      "mainButtonClick":"MODAL",
      "mainButtonModalContent":"M2",
      "mainButtonLink":"",
      "showRenewLink":false,
      "firstLine":"not set",
      "firstLineURL":"Modal",
      "secondLine":"",
      "secondLineURL":"",
      "hideTile":false,
      "btnClass":"ls-btn-primrary-blue"
    },
    "D":{
      "access-msg":"",
      "msg":"Your access expired on",
      "msg-2":'<ul><li class="list pdr">Click <a href="https://blitzkrieg.e-gmat.com/secure-lms/live-sessions/verbal/batch-selector">here</a> to check upcoming batches.</li><li class="list pdb-25">Click on the button below to renew your access.</li></ul>',
      "message_green":"",
      "headingBlack1":"Live Sessions 360",
      "subHeadingBlack":"(LS 360)",
      "mainButtonText":"Renew LS 360",
      "mainButtonClick":"MODAL",
      "mainButtonModalContent":"M3",
      "mainButtonLink":"",
      "firstLine":"not set",
      "firstLineURL":"Modal",
      "showRenewLink":false,
      "secondLine":"",
      "secondLineURL":"",
      "hideTile":false,
      "btnClass":"ls-btn-primrary-blue"
    },
    "E":{
      "access-msg":"",
      "msg":"",
      "msg-2":"",
      "message_green":"",
      "headingBlack1":"",
      "subHeadingBlack":"",
      "mainButtonText":"",
      "mainButtonClick":"NA",
      "mainButtonModalContent":"",
      "mainButtonLink":"",
      "firstLine":"",
      "firstLineURL":"",
      "showRenewLink":false,
      "secondLine":"",
      "secondLineURL":"",
      "hideTile":true,
      "btnClass":""
    },
    "F":{
      "access-msg":"Great!! You have access to LS 360.",
      "msg":"Your access will expire on",
      "msg-2":"<p class='pdb-35'>Manage your batches by clicking on the button below.</p>",
      "message_green":"",
      "headingBlack1":"Live Sessions 360",
      "subHeadingBlack":"(LS 360)",
      "mainButtonText":"Batch Schedule",
      "mainButtonClick":"LINK",
      "mainButtonModalContent":"",
      "mainButtonLink":"https://blitzkrieg.e-gmat.com/secure-lms/live-sessions/verbal/batch-selector",
      "firstLine":"not set",
      "firstLineURL":"Modal",
      "showRenewLink":true,
      "secondLine":"",
      "secondLineURL":"",
      "hideTile":false,
      "btnClass":"ls-btn-primrary-dg"
    },
    "H":{
      "access-msg":"Great!! You have access to LS 360.",
      "msg":"Your access will expire on",
      "msg-2":"<p class='pdb-35'>Manage your batches by clicking on the button below.</p>",
      "message_green":"",
      "headingBlack1":"Live Sessions 360",
      "subHeadingBlack":"(LS 360)",
      "mainButtonText":"Batch Schedule",
      "mainButtonClick":"LINK",
      "mainButtonModalContent":"M2",
      "mainButtonLink":"https://blitzkrieg.e-gmat.com/secure-lms/live-sessions/verbal/batch-selector",
      "firstLine":"not set",
      "firstLineURL":"Modal",
      "showRenewLink":true,
      "secondLine":"",
      "secondLineURL":"",
      "hideTile":false,
      "btnClass":"ls-btn-primrary-dg"
    }

  };

  modalStepConfig:Object = {
    "M1":"m1buylstrial",
    "M2":"m2buylscourse",
    "M3":"m3renwlscourse",
  };
  stepLabel:string = 'lsstep';
  purchaseModalData:object = {
    'm1':{
      'days': '15 days',
      'cost': '$1',
      'b1Message': 'Yes – I would like to',
      'b2Message': 'No – I don’t want to',
      'modalType': 'm1'
    //  'msg': ''
      },
    'm2':{
      'days': '31 days',
      'cost': '$49',
      'b1Message': 'Buy Now',
      'b2Message': 'Buy Later',
      'modalType': 'm2'
    },
    'm3':{
      'days': '31 days',
      'cost': '$49',
      'b1Message': 'Buy Now',
      'b2Message': 'Buy Later',
      'modalType': 'm3'
    }
  };
   liveSessionPurchaseModalData: any;
   message: any;
   message_2: any;
  headingBlack1: any;
  subHeadingBlack: any;
  expiryDate: any;
  expiryDateSubscription: Subscription;
  message_green: 'any';
  accessMsg:any;
  dateMap: any ={
    '1':'st',
    '2':'nd',
    '3':'rd',
    '21':'st',
    '22':'nd',
    '23':'rd',
    "31":'st'
  };
  destroy: boolean = false;
  trialOfferExpiryDateSubscribe: Subscription;
  trialOfferExpiryDate: any;
  showRenewLink:boolean=false;
  maxNumOfDaysToExpire:number=7;
  daysToExpire:number=30;
  @HostListener('window:resize', ['$event'])
onResize(event) {
  this.screenSize=event.target.innerWidth;
}
  constructor(private httpClientService: HttpClientService, private activatedRoute: ActivatedRoute, private router: Router, private sessionService:SessionService, private eventService: EventService) {

    this.sectionSubscription = this.sessionService.sharedSectionName$.subscribe((section)=>{
     if(section!=""&&section!=undefined&&section!=null)
      {
        this.section = section;
        this.expiryDateSubscription = this.sessionService.sharedExpiryDate.subscribe((date)=>{
         // date = 1597035855000;
          if(date!=null && date!=''){
            var expiryDate = new Date(date);
            this.daysToExpire = this.calculateDaysToExpire(date); //get number of days left for trial to expire
            var day = expiryDate.getDate();
            var months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
            var currentMonth = months[expiryDate.getMonth()];
            var year = expiryDate.getFullYear();
            var hours = expiryDate.getHours();
            var minutes = expiryDate.getMinutes();
            var power = this.dateMap[day]?this.dateMap[day]:'th';
            if(hours>12){
              var timeunit = 'PM';
              hours = hours - 12;
            }
            else if(hours == 12){
              var timeunit = 'PM';
            }
            else if(hours == 0){
              var timeunit = 'AM';
               hours = 12;
            }
            else if(hours<10){
              // hours = hours.toString();
              var hourString = '0'+hours.toString();
              var timeunit = 'AM';
            }
            else {
              var timeunit = 'AM';
            }
            if(hours<10){
              var hourString = '0'+hours.toString();
            }
            if(minutes<10){
              var minutesString="0"+minutes.toString();
            }
            if(hours<10 && hourString!=undefined && minutes>=10)
            {
            this.expiryDate = day+power+' '+currentMonth+ ' ' +year+ ' '+hourString+':'+minutes+' '+timeunit+'.';
            }
            else if(hours<10 && hourString!=undefined && minutesString!=undefined && minutes<10)
            {
              this.expiryDate = day+power+' '+currentMonth+ ' ' +year+ ' '+hourString+':'+minutesString+' '+timeunit+'.';
            }
            else if(hours>=10 && minutes<10 && minutesString!=undefined)
            {
              this.expiryDate = day+power+' '+currentMonth+ ' ' +year+ ' '+hours+':'+minutesString+' '+timeunit+'.';
            }
            else {
              this.expiryDate = day+power+' '+currentMonth+ ' ' +year+ ' '+hours+':'+minutes+' '+timeunit+'.';
            }
            if(this.firstLine == 'not set' && this.expiryDate!='' && this.expiryDate!=undefined){
              this.firstLine = this.expiryDate;
            }
          }
          else {
            this.expiryDate = '';
          }
        });
        this.trialOfferExpiryDateSubscribe = this.sessionService.sharedTirialOfferExpiryDate.subscribe((date) => {
          //date = 1597035855000;
          if (date != null) {
            this.trialOfferExpiryDate = date;
          }
          else {
            this.trialOfferExpiryDate = '';
          }
        });
      this.sectionSubscription = this.sessionService.sharedGettingVerbalLsState.subscribe((state)=>{
        this.state = state;
        if(this.state!='B') {
          this.setTemplate();
        }
        else{
          this.hideTileContainer = true;
        }
      });
      }
    });
   }

  ngOnInit()
  {
    this.screenSize=window.innerWidth;
  }

  setTemplate()
  {
    let keyExists = this.checkStateExists();
    console.log(keyExists,this.section=="VERBAL");
    //if(keyExists)
    if(keyExists && this.section=="VERBAL")
    {
        this.hideTileContainer = this.lsInfoTemplateConfig[this.state]['hideTile'];
        this.btnClass = this.lsInfoTemplateConfig[this.state]['btnClass'];
        this.mainButtonText = this.lsInfoTemplateConfig[this.state]['mainButtonText'];
        this.firstLine = this.lsInfoTemplateConfig[this.state]['firstLine'];
        if(this.firstLine == 'not set' && this.expiryDate!='' && this.expiryDate!=undefined){
          this.firstLine = this.expiryDate;
        }
        this.firstLineURL = this.lsInfoTemplateConfig[this.state]['firstLineURL'];
        this.secondLine = this.lsInfoTemplateConfig[this.state]['secondLine'];
        this.secondLineURL = this.lsInfoTemplateConfig[this.state]['secondLineURL'];
        this.message = this.lsInfoTemplateConfig[this.state]['msg'];
        this.message_2 = this.lsInfoTemplateConfig[this.state]['msg-2'];
        this.message_green = this.lsInfoTemplateConfig[this.state]['message_green'];
        this.accessMsg = this.lsInfoTemplateConfig[this.state]['access-msg'];
        this.headingBlack1 = this.lsInfoTemplateConfig[this.state]['headingBlack1'];
        this.subHeadingBlack = this.lsInfoTemplateConfig[this.state]['subHeadingBlack'];
        this.showRenewLink = this.lsInfoTemplateConfig[this.state]['showRenewLink'];
        if(this.showRenewLink && this.daysToExpire <= this.maxNumOfDaysToExpire)
        {
          this.firstLine += " (<u>Renew</u>)";
        }
    }
    else
    {
      this.hideTileContainer = true;
    }

    if(this.state == 'B'){
      this.liveSessionPurchaseModalData = this.purchaseModalData['m1'];
    }
    if(this.state == 'C' || this.state == 'H'){
      this.liveSessionPurchaseModalData = this.purchaseModalData['m2'];
    }
    if(this.state == 'D'){
      this.liveSessionPurchaseModalData = this.purchaseModalData['m3'];
    }
    this.sessionService.sharepurchaseModalStarted(this.liveSessionPurchaseModalData);
  }
  ngOnChanges() {
    this.screenSize=window.innerWidth;

  }
  calculateDaysToExpire(date)
  {
    let currentDate = new Date().getTime(); //timestamp for current time.
    let expiryDate = date; //expiry date's timestamp from server
    let daysToExpire = (expiryDate - currentDate)/(24*60*60*1000); // converting the difference to days.
    return Math.round(daysToExpire);
  }
  checkStateExists()
  {
      if(this.state!='' && this.state!=null && this.state!=undefined)
      {
        let keys = Object.keys(this.lsInfoTemplateConfig).indexOf(this.state);
        return keys>-1?true:false;
      }
      else
      {
        return false;
      }
  }
  blurBackground(action:string)
  {
   if(action=== 'add')
   {
     document.body.classList.add('coursePopIn');
   }
   else
   {
     document.body.classList.remove('coursePopIn');
   }

  }
  mainButtonClick()
  {
    this.destroy = false;
    let action = this.lsInfoTemplateConfig[this.state]['mainButtonClick'];
    if(action=="MODAL")
    {
      this.modalIdentifier = this.lsInfoTemplateConfig[this.state]['mainButtonModalContent'];
      let stepValue = this.modalStepConfig[this.modalIdentifier];
      let url = window.location.href;
      let pageName = url.split('/')[url.split('/').length-1];
      let pageProperties = this.pageProperties(stepValue);
      this.eventService.page(pageName,pageProperties);
      this.showPurchaseModal=true;
    }
    else if(action=="LINK")
    {
      let link = this.lsInfoTemplateConfig[this.state]['mainButtonLink'];
      if(this.state=='A'){
          window.open(link,'_blank');
      }
      else {
        window.location.href = link;
      }
    }
  }

  pageProperties(stepValue)
  {
    let properties = {};
    properties['path'] =  window.location.pathname;
    properties['referrer'] = document.referrer;
    properties['search'] =  window.location.search;
    properties['title'] = document.title;
    properties['url'] = window.location.href+'/?'+this.stepLabel+"="+stepValue;
    return properties;
  }

  firstLineClick()
  {
    this.destroy = false;
    if(this.firstLineURL == 'Modal'){
      if(this.state == 'C' || this.state == 'H'){
        this.liveSessionPurchaseModalData = this.purchaseModalData['m2'];
      }
      if(this.state == 'D' || this.state == 'F'){
        this.liveSessionPurchaseModalData = this.purchaseModalData['m3'];
      }
      this.sessionService.sharepurchaseModalStarted(this.liveSessionPurchaseModalData);
      this.showPurchaseModal=true;
    }
    else {
      window.location.href = this.firstLineURL;
    }
  }

  secondLineClick()
  {

  }

  ngOnDestroy()
  {
    if(this.sectionSubscription)
    {
      this.sectionSubscription.unsubscribe();
    }
  }

  onModalClose($event: any) {
    this.showPurchaseModal = false;
    if(this.showPurchaseModal==false){
      this.destroy = true;
    }
  }
}
